module.exports = __webpack_public_path__ + "img/learn_more_arrow.83be7726.svg";